// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F3b5","controls":"styles_controls__13p5l","charLimit":"styles_charLimit__2wxhM","input":"styles_input__2xBf1","send":"styles_send__2ZwDn"};